/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: sW27sgRtpNjK
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import AppShell from "../../AppShell"; // plasmic-import: Vh273IDurq9t/component
import WebTab from "../../WebTab"; // plasmic-import: XNSjqwwbHvXu/component
import WebTopNav from "../../WebTopNav"; // plasmic-import: tGgk6oqzsXGR/component
import Breadcrumb from "../../Breadcrumb"; // plasmic-import: k0sjE64BjPfV/component
import ButtonSecondary from "../../ButtonSecondary"; // plasmic-import: yzRkzInaRral/component
import ContainerInTab from "../../ContainerInTab"; // plasmic-import: _lT-Lq7an5i5/component
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: cGXW91A7jag-/component
import WebDock from "../../WebDock"; // plasmic-import: EtVLWfl2KEmA/component
import ButtonDock from "../../ButtonDock"; // plasmic-import: utQE8oqBBjiK/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebHomepage.module.css"; // plasmic-import: sW27sgRtpNjK/css
import Icon30Icon from "./icons/PlasmicIcon__Icon30"; // plasmic-import: v-1PLPXOc6tO/icon
import Icon23Icon from "./icons/PlasmicIcon__Icon23"; // plasmic-import: YwlgzG5yARIP/icon
import Icon34Icon from "./icons/PlasmicIcon__Icon34"; // plasmic-import: 3VA-qZnm8pUB/icon
import Icon32Icon from "./icons/PlasmicIcon__Icon32"; // plasmic-import: dWHMt3F1tCmW/icon
import Icon33Icon from "./icons/PlasmicIcon__Icon33"; // plasmic-import: h408FMoSv0qx/icon
import Icon15Icon from "./icons/PlasmicIcon__Icon15"; // plasmic-import: KZeS8_m5UsgE/icon
import Icon27Icon from "./icons/PlasmicIcon__Icon27"; // plasmic-import: WzMsUn33Iqfb/icon
import Icon26Icon from "./icons/PlasmicIcon__Icon26"; // plasmic-import: flPWDcL8BgpD/icon

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "o21p",
    openGraph: {
      title: "o21p"
    },
    twitter: {
      card: "summary",
      title: "o21p"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicWebHomepage__VariantProps = new Array();

export const PlasmicWebHomepage__ArgProps = new Array();

const $$ = {};

function PlasmicWebHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"pageWorkspace"}
        data-plasmic-override={overrides.pageWorkspace}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.pageWorkspace
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <WebTab
              data-plasmic-name={"webTab"}
              data-plasmic-override={overrides.webTab}
              className={classNames("__wab_instance", sty.webTab)}
              tabContent={
                <ContainerInTab
                  data-plasmic-name={"containerInTab"}
                  data-plasmic-override={overrides.containerInTab}
                  className={classNames("__wab_instance", sty.containerInTab)}
                  padding={"global"}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__my49I)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__hjlPd)}
                    >
                      <h1
                        data-plasmic-name={"h1"}
                        data-plasmic-override={overrides.h1}
                        className={classNames(
                          projectcss.all,
                          projectcss.h1,
                          projectcss.h1__fRuRb,
                          projectcss.__wab_text,
                          sty.h1
                        )}
                      >
                        {"digital infrastructure \nfor the independent."}
                      </h1>
                      <div
                        data-plasmic-name={"text"}
                        data-plasmic-override={overrides.text}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text
                        )}
                      >
                        {
                          "Lorem ipsum dolor sit amet consectetur. Ac ipsum nulla ut nisl. Diam ornare amet fermentum quisque elit gravida. Consectetur enim sed egestas ligula sollicitudin."
                        }
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__mygpB)}
                    >
                      <ButtonPrimary
                        data-plasmic-name={"buttonPrimary"}
                        data-plasmic-override={overrides.buttonPrimary}
                        color={"brand"}
                        content={"sign up free"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebSignupTemp"] = true
                            ? (() => {
                                const actionArgs = { destination: `/signup` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebSignupTemp"] != null &&
                            typeof $steps["goToWebSignupTemp"] === "object" &&
                            typeof $steps["goToWebSignupTemp"].then ===
                              "function"
                          ) {
                            $steps["goToWebSignupTemp"] =
                              await $steps["goToWebSignupTemp"];
                          }
                        }}
                        showIcon={false}
                        size={"medium"}
                        ststus={"normal"}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__iCbNw
                        )}
                        color={"primaryBrand"}
                        content={"explore the o21p gallery"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebGallery"] = true
                            ? (() => {
                                const actionArgs = { destination: `/gallery` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebGallery"] != null &&
                            typeof $steps["goToWebGallery"] === "object" &&
                            typeof $steps["goToWebGallery"].then === "function"
                          ) {
                            $steps["goToWebGallery"] =
                              await $steps["goToWebGallery"];
                          }
                        }}
                      />
                    </div>
                  </div>
                </ContainerInTab>
              }
              tabDock={
                <WebDock
                  data-plasmic-name={"webDock"}
                  data-plasmic-override={overrides.webDock}
                  className={classNames("__wab_instance", sty.webDock)}
                  modulesWrapper={
                    <React.Fragment>
                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__qKuFw
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___2D1U
                            )}
                          >
                            <Icon30Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__gi4Fv
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebWorkspace"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/workspace`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebWorkspace"] != null &&
                            typeof $steps["goToWebWorkspace"] === "object" &&
                            typeof $steps["goToWebWorkspace"].then ===
                              "function"
                          ) {
                            $steps["goToWebWorkspace"] =
                              await $steps["goToWebWorkspace"];
                          }
                        }}
                        status={"selected"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__qkAo
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__noCIw
                            )}
                          >
                            <Icon23Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__qqc0D
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebRoadmap"] = true
                            ? (() => {
                                const actionArgs = { destination: `/roadmap` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebRoadmap"] != null &&
                            typeof $steps["goToWebRoadmap"] === "object" &&
                            typeof $steps["goToWebRoadmap"].then === "function"
                          ) {
                            $steps["goToWebRoadmap"] =
                              await $steps["goToWebRoadmap"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__lec81
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___4ZLfz
                            )}
                          >
                            <Icon34Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__hh1Nu
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebTheIndependent"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/the-independent`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebTheIndependent"] != null &&
                            typeof $steps["goToWebTheIndependent"] ===
                              "object" &&
                            typeof $steps["goToWebTheIndependent"].then ===
                              "function"
                          ) {
                            $steps["goToWebTheIndependent"] =
                              await $steps["goToWebTheIndependent"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock___3KNkP
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___4OwxZ
                            )}
                          >
                            <Icon32Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__zjtmF
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebDemo"] = true
                            ? (() => {
                                const actionArgs = { destination: `/demo` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebDemo"] != null &&
                            typeof $steps["goToWebDemo"] === "object" &&
                            typeof $steps["goToWebDemo"].then === "function"
                          ) {
                            $steps["goToWebDemo"] = await $steps["goToWebDemo"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__nEd8T
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__s27JG
                            )}
                          >
                            <Icon33Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__n9Or1
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebFiles"] = true
                            ? (() => {
                                const actionArgs = { destination: `/files` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebFiles"] != null &&
                            typeof $steps["goToWebFiles"] === "object" &&
                            typeof $steps["goToWebFiles"].then === "function"
                          ) {
                            $steps["goToWebFiles"] =
                              await $steps["goToWebFiles"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__xsDzk
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__vu2ZU
                            )}
                          >
                            <Icon15Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__jq5I
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebSupport"] = true
                            ? (() => {
                                const actionArgs = { destination: `/support` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebSupport"] != null &&
                            typeof $steps["goToWebSupport"] === "object" &&
                            typeof $steps["goToWebSupport"].then === "function"
                          ) {
                            $steps["goToWebSupport"] =
                              await $steps["goToWebSupport"];
                          }
                        }}
                        status={"_default"}
                      />

                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox___9GToV
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__kirXa
                          )}
                        />
                      </div>
                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__eFfpd
                        )}
                        color={"dark"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__ux9Mv
                            )}
                          >
                            <Icon27Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__aedyF
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebGallery"] = true
                            ? (() => {
                                const actionArgs = { destination: `/gallery` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebGallery"] != null &&
                            typeof $steps["goToWebGallery"] === "object" &&
                            typeof $steps["goToWebGallery"].then === "function"
                          ) {
                            $steps["goToWebGallery"] =
                              await $steps["goToWebGallery"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__cD2Sf
                        )}
                        color={"dark"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__buRsa
                            )}
                          >
                            <Icon26Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__z38Wt
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebPartnersCommunity"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/partners-community`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebPartnersCommunity"] != null &&
                            typeof $steps["goToWebPartnersCommunity"] ===
                              "object" &&
                            typeof $steps["goToWebPartnersCommunity"].then ===
                              "function"
                          ) {
                            $steps["goToWebPartnersCommunity"] =
                              await $steps["goToWebPartnersCommunity"];
                          }
                        }}
                        status={"_default"}
                      />
                    </React.Fragment>
                  }
                />
              }
              tabNav={
                <WebTopNav
                  data-plasmic-name={"webTopNav"}
                  data-plasmic-override={overrides.webTopNav}
                  className={classNames("__wab_instance", sty.webTopNav)}
                  pageButtons={
                    <React.Fragment>
                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__al9Wv
                        )}
                        color={"tertiary"}
                        content={"partner"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToHttpsPartnerO21PCom"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: "https://partner.o21p.com/"
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToHttpsPartnerO21PCom"] != null &&
                            typeof $steps["goToHttpsPartnerO21PCom"] ===
                              "object" &&
                            typeof $steps["goToHttpsPartnerO21PCom"].then ===
                              "function"
                          ) {
                            $steps["goToHttpsPartnerO21PCom"] =
                              await $steps["goToHttpsPartnerO21PCom"];
                          }
                        }}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__rhFcA
                        )}
                        color={"tertiary"}
                        content={"team"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToHttpsTeamO21PCom"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: "https://team.o21p.com/"
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToHttpsTeamO21PCom"] != null &&
                            typeof $steps["goToHttpsTeamO21PCom"] ===
                              "object" &&
                            typeof $steps["goToHttpsTeamO21PCom"].then ===
                              "function"
                          ) {
                            $steps["goToHttpsTeamO21PCom"] =
                              await $steps["goToHttpsTeamO21PCom"];
                          }
                        }}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__th5Jx
                        )}
                        color={"tertiary"}
                        content={"nexus"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToHttpsNexusO21PCom"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: "https://nexus.o21p.com/"
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToHttpsNexusO21PCom"] != null &&
                            typeof $steps["goToHttpsNexusO21PCom"] ===
                              "object" &&
                            typeof $steps["goToHttpsNexusO21PCom"].then ===
                              "function"
                          ) {
                            $steps["goToHttpsNexusO21PCom"] =
                              await $steps["goToHttpsNexusO21PCom"];
                          }
                        }}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__v23OL
                        )}
                        color={"tertiary"}
                        content={"support"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebCompassSupport"] = true
                            ? (() => {
                                const actionArgs = { destination: `/support` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebCompassSupport"] != null &&
                            typeof $steps["goToWebCompassSupport"] ===
                              "object" &&
                            typeof $steps["goToWebCompassSupport"].then ===
                              "function"
                          ) {
                            $steps["goToWebCompassSupport"] =
                              await $steps["goToWebCompassSupport"];
                          }
                        }}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary___50P85
                        )}
                        color={"tertiary"}
                        content={"legal"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToPage"] = true
                            ? (() => {
                                const actionArgs = {};
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToPage"] != null &&
                            typeof $steps["goToPage"] === "object" &&
                            typeof $steps["goToPage"].then === "function"
                          ) {
                            $steps["goToPage"] = await $steps["goToPage"];
                          }
                        }}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__gqbS5
                        )}
                        color={"tertiary"}
                        content={"sign up free"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebSignupTemp"] = true
                            ? (() => {
                                const actionArgs = { destination: `/signup` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebSignupTemp"] != null &&
                            typeof $steps["goToWebSignupTemp"] === "object" &&
                            typeof $steps["goToWebSignupTemp"].then ===
                              "function"
                          ) {
                            $steps["goToWebSignupTemp"] =
                              await $steps["goToWebSignupTemp"];
                          }
                        }}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary___14LjN
                        )}
                        color={"tertiary"}
                        content={"log in"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebLogin"] = true
                            ? (() => {
                                const actionArgs = { destination: `/login` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebLogin"] != null &&
                            typeof $steps["goToWebLogin"] === "object" &&
                            typeof $steps["goToWebLogin"].then === "function"
                          ) {
                            $steps["goToWebLogin"] =
                              await $steps["goToWebLogin"];
                          }
                        }}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__bqczo
                        )}
                        color={"primary"}
                        content={"x"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebWorkspace"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/workspace`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebWorkspace"] != null &&
                            typeof $steps["goToWebWorkspace"] === "object" &&
                            typeof $steps["goToWebWorkspace"].then ===
                              "function"
                          ) {
                            $steps["goToWebWorkspace"] =
                              await $steps["goToWebWorkspace"];
                          }
                        }}
                      />
                    </React.Fragment>
                  }
                  pageTitle={
                    <Breadcrumb
                      data-plasmic-name={"breadcrumb"}
                      data-plasmic-override={overrides.breadcrumb}
                      className={classNames("__wab_instance", sty.breadcrumb)}
                      crumbCount={"justTitle"}
                      sidePadding={"_default"}
                      size={"navS"}
                      tabTitle={"o21p"}
                    />
                  }
                />
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageWorkspace: [
    "pageWorkspace",
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "containerInTab",
    "h1",
    "text",
    "buttonPrimary",
    "webDock"
  ],

  appShell: [
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "containerInTab",
    "h1",
    "text",
    "buttonPrimary",
    "webDock"
  ],

  webTab: [
    "webTab",
    "webTopNav",
    "breadcrumb",
    "containerInTab",
    "h1",
    "text",
    "buttonPrimary",
    "webDock"
  ],

  webTopNav: ["webTopNav", "breadcrumb"],
  breadcrumb: ["breadcrumb"],
  containerInTab: ["containerInTab", "h1", "text", "buttonPrimary"],
  h1: ["h1"],
  text: ["text"],
  buttonPrimary: ["buttonPrimary"],
  webDock: ["webDock"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebHomepage__ArgProps,
          internalVariantPropNames: PlasmicWebHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageWorkspace") {
    func.displayName = "PlasmicWebHomepage";
  } else {
    func.displayName = `PlasmicWebHomepage.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "fRuRbcdHVNMtdcnFK96ivt"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicWebHomepage = Object.assign(
  // Top-level PlasmicWebHomepage renders the root element
  withUsePlasmicAuth(makeNodeComponent("pageWorkspace")),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    webTab: makeNodeComponent("webTab"),
    webTopNav: makeNodeComponent("webTopNav"),
    breadcrumb: makeNodeComponent("breadcrumb"),
    containerInTab: makeNodeComponent("containerInTab"),
    h1: makeNodeComponent("h1"),
    text: makeNodeComponent("text"),
    buttonPrimary: makeNodeComponent("buttonPrimary"),
    webDock: makeNodeComponent("webDock"),
    // Metadata about props expected for PlasmicWebHomepage
    internalVariantProps: PlasmicWebHomepage__VariantProps,
    internalArgProps: PlasmicWebHomepage__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/",
      pagePath: "/",
      params: {},
      query: {}
    })
  }
);

export default PlasmicWebHomepage;
/* prettier-ignore-end */
